import React from "react";
import { SimpleGrid, Text, Box, Image, Button, Center, Skeleton } from "@chakra-ui/react"
import profile from "../../images/profile.jpg"
import { FaGithub, FaLinkedin, FaRegEnvelope, FaRegFilePdf } from "react-icons/fa"
import "./styles.scss"
import cv from "../../../public/adrienne-rio-resume.pdf"
import Background from "../../components/Layout/Background";
import a from "../../images/background/2.svg"
import b from "../../images/background/76.svg"
import c from "../../images/background/43.svg"
import d from "../../images/background/14.svg"
import e from "../../images/background/101.svg"
import f from "../../images/background/58.svg"


export default function Main() {
    const redirect = (link) => {
        if (typeof window !== "undefined")
            window.open(link, '_blank')
        
    }

    const sendMail = () => {
        if (typeof window !== "undefined")
            window.location.href = "mailto:riowongsoatmojo@gmail.com";
    }
    
    return (
        <>
            <Box p="relative" d="flex" h={["80vh", "80vh", "75vh", "75vh"]} alignItems="center">
                <Background src={a} right="-10vw" top={0} width="22vw" />
                <Background src={b} right="6vw" top="19vw" width="10vw" />
                <Background src={c} left="-5vw" top="40vw" width="12vw" />
                <Background src={d} left="4vw" top="34vw" width="4vw" />
                <Background src={e} left="8vw" top="10vw" width="8vw" />
                <Background src={f} right="5vw" top="45vw" width="6vw" />

                <SimpleGrid
                    rows={[2, 2, 2, 1]}
                    columns={[1, 1, 1, 2]}
                >
                    <Box p="relative" d="flex" justifyContent="center" pr={[0, 0, "2vw", "3vw"]}>
                        <Image src={profile} borderRadius={20} h={[300, 350, 400, 450]} textAlign="center" fallback={<Skeleton borderRadius={20} h={[300, 350, 400, 450]} />}/>
                    </Box>
                    <Box alignSelf="center">
                        <Text fontSize={[46, 50, 70, 70]} fontWeight={700} pt={5}>Adrienne Rio.</Text>
                        <Text fontSize={[14, 16, 18, 18]} fontWeight={400}>
                            Hi there! I am a final year Computer Science student currently studying at
                            Monash University. I have an obsession with creating apps that solves simple 
                            or even complex problems. Currently passionate in learning to build highly-scalable systems.
                        </Text>
                        <SimpleGrid rows={[4, 4, 1, 1]} columns={[1, 1, 4, 4]} spacing={4} mt={6}>
                            <Button leftIcon={<FaRegFilePdf/>} colorScheme="orange">
                                <a href={cv} target="_blank">
                                    <Text fontSize={[16, 16, 14, 14]}>Resume</Text>
                                </a>
                            </Button>
                            {/* <Button leftIcon={<FaWhatsapp />} colorScheme="whatsapp">WhatsApp</Button> */}
                            <Button onClick={() => redirect('https://www.linkedin.com/in/adrienne-rio/')} leftIcon={<FaLinkedin />} colorScheme="linkedin">
                                <Text fontSize={[16, 16, 14, 14]}>LinkedIn</Text>   
                            </Button>
                            <Button onClick={() => redirect('https://github.com/idea456')} leftIcon={<FaGithub />} color="white" bg="black">
                                <Text fontSize={[16, 16, 14, 14]}>Github</Text>   
                            </Button>
                            <Button onClick={() => sendMail()} leftIcon={<FaRegEnvelope />} colorScheme="red">
                                <Text fontSize={[16, 16, 14, 14]}>Email</Text>   
                            </Button>
                        </SimpleGrid>
                    </Box>
                </SimpleGrid>
            </Box>
            <Box py={[20, 10, 0, 0]}>
                <Center>
                    <Text fontSize="4xl">⬇️</Text>
                </Center>
            </Box>
        </>
    )
}